/**
 * 商品ソート・フィルタリング用のユーティリティ関数
 */

/**
 * キーワード検索でフィルタリング
 * @param {Array} productList - 商品リスト
 * @param {string} keyword - 検索キーワード
 * @returns {Array} フィルタリングされた商品リスト
 */
export function filterByKeyword(productList, keyword) {
  if (!keyword) {
    return [...productList];
  }

  const keys = keyword.replace(',', '|');
  const keyReg = new RegExp(keys, 'i');
  
  return productList.filter(product => {
    // タイトルで検索
    if (keyReg.test(product.title)) {
      return true;
    }
    
    // カテゴリのdisplayNameで検索
    return product.categories.some(category => 
      keyReg.test(category.displayName)
    );
  });
}

/**
 * 在庫状況でフィルタリング
 * @param {Array} productList - 商品リスト
 * @param {string} stockFilter - 在庫フィルター ('exist' または '0')
 * @param {Function} judgeStatus - 在庫状況判定関数
 * @returns {Array} フィルタリングされた商品リスト
 */
export function filterByStock(productList, stockFilter, judgeStatus) {
  if (stockFilter !== 'exist') {
    return [...productList];
  }

  return productList.filter(product => {
    const customStatus = product.categories.filter(cat => cat.groupName === 'statusOption');
    const status = judgeStatus(product.variations, product.categories);
    
    return status === 'exist' || 
           status === 'btoo' || 
           status === customStatus[0]?.name;
  });
}

/**
 * カテゴリでフィルタリング
 * @param {Array} productList - 商品リスト
 * @param {string} categoryFilter - カテゴリフィルター
 * @returns {Array} フィルタリングされた商品リスト
 */
export function filterByCategory(productList, categoryFilter) {
  if (categoryFilter === '0') {
    return [...productList];
  }

  return productList.filter(product => 
    product.categories.some(category => category.name === categoryFilter)
  );
}

/**
 * 価格でソート
 * @param {Array} productList - 商品リスト
 * @param {string} sortType - ソートタイプ ('row', 'high', '0')
 * @returns {Array} ソートされた商品リスト
 */
export function sortByPrice(productList, sortType) {
  const sortedList = [...productList];
  
  switch (sortType) {
    case 'row':
      // 安い順
      return sortedList.sort((a, b) => a.variations[0].price - b.variations[0].price);
    case 'high':
      // 高い順
      return sortedList.sort((a, b) => b.variations[0].price - a.variations[0].price);
    default:
      // デフォルト（新着順など）
      return sortedList;
  }
}

/**
 * 商品リストの総合的なフィルタリング・ソート処理
 * @param {Object} params - パラメータオブジェクト
 * @param {Array} params.productList - 元の商品リスト
 * @param {string} params.keyword - 検索キーワード
 * @param {string} params.stockFilter - 在庫フィルター
 * @param {string} params.categoryFilter - カテゴリフィルター
 * @param {string} params.sortType - ソートタイプ
 * @param {Function} params.judgeStatus - 在庫状況判定関数
 * @returns {Array} 処理済みの商品リスト
 */
export function processProductList({
  productList,
  keyword,
  stockFilter,
  categoryFilter,
  sortType,
  judgeStatus
}) {
  let filteredList = productList;
  
  // 1. キーワード検索
  filteredList = filterByKeyword(filteredList, keyword);
  
  // 2. 在庫フィルター
  filteredList = filterByStock(filteredList, stockFilter, judgeStatus);
  
  // 3. カテゴリフィルター
  filteredList = filterByCategory(filteredList, categoryFilter);
  
  // 4. ソート
  filteredList = sortByPrice(filteredList, sortType);
  
  return filteredList;
}
